import { render, staticRenderFns } from "./employ_info.vue?vue&type=template&id=5f6b83a6&scoped=true&"
import script from "./employ_info.vue?vue&type=script&lang=js&"
export * from "./employ_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b83a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6b83a6')) {
      api.createRecord('5f6b83a6', component.options)
    } else {
      api.reload('5f6b83a6', component.options)
    }
    module.hot.accept("./employ_info.vue?vue&type=template&id=5f6b83a6&scoped=true&", function () {
      api.rerender('5f6b83a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/employees/modal/tabs/employ_info.vue"
export default component.exports